const state = {
    service_list :'',
    current_index :0,
};

const mutations = {
     set_service_list(state,val){
         state.service_list = val
     },
    set_current_index(state,val){
         state.current_index = val
    }
};

const actions = {

};

const getters = {

};

export default {
    state,
    mutations,
    actions,
    getters
}
